import { Subject } from 'rxjs';

import { Utils } from '../utils/utils';

import { ItemType } from '../models/item.model';
import { MapItem } from '../models/weavix-map.model';

import { PermissionAction } from '../permissions/permissions.model';
import { ItemService } from './item.service';
import { ProfileService } from './profile.service';
import { StateServiceBase, StateUpdate } from './state-base.service';

export class ItemStateService extends StateServiceBase {
    items = new Map<string, MapItem>();
    itemTypes = new Map<string, ItemType>();

    items$ = new Subject<StateUpdate<MapItem>>();
    itemTypes$ = new Subject<StateUpdate<ItemType>>();

    constructor(
        private readonly itemService: ItemService,
        private readonly profileService: ProfileService,
    ) {
        super();
    }

    async loadData(c: any, accountId: string, facilityId?: string, tags?: string[]) {
        if (!this.profileService.hasPermission(PermissionAction.ViewSites, facilityId)) return;

        const [itemTypes, items] = await Promise.all([
            this.itemService.getAllTypes(c, tags, false),
            this.itemService.getItems(c, facilityId, true, tags, false),
        ]);
        this.items = Utils.toMap(items.filter(x => this.profileService.hasPermission(PermissionAction.ViewSites, facilityId, x.folderId)));
        this.itemTypes = Utils.toMap(itemTypes);
    }

    async stop() {
        super.stop();
        this.items.clear();
        this.itemTypes.clear();
    }

    protected async setupSubscriptions(c: any, accountId: string, facilityId?: string) {
        return [
            this.profileService.hasPermission(PermissionAction.ViewSites, facilityId)
                && (await this.itemService.subscribeUpdates(c)).subscribe(async (result) => {
                    if (result.payload.items) {
                        const itemMap = result.payload.items;
                        const filtered = {};
                        Object.keys(itemMap).forEach(id => {
                            if (!itemMap[id] || this.profileService.hasPermission(PermissionAction.ViewSites, facilityId, itemMap[id].folderId)) {
                                filtered[id] = itemMap[id];
                            }
                        });
                        this.updateFromMap(this.items, filtered, this.items$);
                    } else if (result.payload.itemTypes) {
                        const itemTypeMap = result.payload.itemTypes;
                        this.updateFromMap(this.itemTypes, itemTypeMap, this.itemTypes$);
                    }
                }),
        ];
    }
}
